import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'limit',
  version: '1.1.0',
  properties: [
    {
      key: 'inputArray',
      label: 'Input Array',
      type: 'string',
      required: true,
      placeholder: 'e.g., {{ $node["Data Engine API"].output.data }}',
      description: 'The array to limit. Drag from the input panel or type the path.',
    },
    {
      key: 'limit',
      label: 'Limit',
      type: 'number',
      required: true,
      default: 10,
      description: 'Maximum number of items to return',
    },
    {
      key: 'skip',
      label: 'Skip',
      type: 'number',
      required: false,
      default: 0,
      description: 'Number of items to skip from the beginning',
    },
  ],
};

export default schema;
